<div class="top">

    <div class="pricing_services">
        <div class="container-fluid">
            <div style="width: 80%;margin: 10px auto;">
                <h3 align="center">Service Charge Calculator</h3>
                <p style="margin-left: 30px;text-align: center;margin-top:
                    20px;">You can calculate the estimated yourDesiCart service
                    charges using below calculator. Service charges are in
                    addition to the International Shipping Charges. Service
                    Charges will be applied to the services you avail. </p>
            </div>

            <form [formGroup]="pricingform" (ngSubmit)="getShippingRates()">
                <div class="row">
                    <div class="row col-md-12 col-lg-12 col-xl-12">
                        <div class="card">
                            <!-- <div class="card-header bg-light">
                                <h5 align="center">Service Charge Calculator</h5>
                                <p align="center">You can calculate the estimated yourDesiCart service charges using below calculator. Service charges are in addition to the International Shipping Charges. Service Charges will be applied to the services you avail. </p>
                            </div> -->
                            <div class="card-body">
                                <div class="row col-md-12 col-lg-12
                                    col-xl-12">
                                    <div class="col-md-10 col-sm-10 col-xl-10">
                                        <table width="100%">
                                            <tbody>
                                                <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                    <div class="col-sm-3 col-md-3">
                                                        <td>
                                                            <b><label>Base Charge:</label></b>
                                                        </td>
                                                    </div>
                                                    <div class="col-sm-4 col-md-4">
                                                        <td>
                                                            <input type="text"
                                                                class="form-control"
                                                                value="Rs.750" size="40"
                                                                readonly>
                                                        </td>
                                                    </div>
                                                    <div class="col-sm-5 col-md-5">
                                                        <td>
                                                            <p ><i class="fa
                                                                    fa-cart-plus"
                                                                    style="margin-right:
                                                                    5px;font-size:
                                                                    18px;"></i>Flat
                                                    Fee applied to each
                                                                international
                                                                shipment.</p>
                                                        </td>
    
                                                    </div>
                                                </tr>
                                                
                                                <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                    <div class="col-sm-3 col-md-3">
                                                        <td>
                                                            <b> <label>Personal
                                                                    Shopper Service:</label></b>
                                                        </td>
                                                    </div>
                                                    <div class="col-sm-4 col-md-4">
                                                        <td>
                                                            <textarea type="text"
                                                                rows="2"  size="40"
                                                                class="form-control"
                                                                placeholder="Estimated cost of items you want the shopper to buy on your behalf from India"
                                                                formControlName="pshopper"></textarea>
                                                        </td>
                                                    </div>
                                                    <div class="col-sm-5 col-md-5">
                                                        <td>
                                                            <p ><b>Rs.
                                                                    299 + 4%</b> of
                                                                cost entered.
                                                                Commute charges to
                                                                buy the products
                                                                will be additional.</p>
                                                        </td>
                                                    </div>
                                                    
                                                   
                                                    
                                                </tr>
                                                <!-- <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                    <div class="col-sm-3 col-md-3">
                                                        <td>
                                                            <b><label>Pickup/Drop
                                                                    Off Service:</label></b>
                                                        </td>
                                                    </div>
                                                    <div class="col-sm-4 col-md-4">
                                                        <td>
                                                            <textarea type="text"
                                                                rows="2"  size="40"
                                                                class="form-control"
                                                                placeholder="enter the estimated weight of the package to be pickedup"
                                                                formControlName="weight"></textarea>
                                                        </td>
                                                    </div>
                                                    <div class="col-sm-5 col-md-5">
                                                        <td>
                                                            <p ><b>Rs.
                                                                    299</b> +
                                                                domestic (within
                                                                India) package
                                                                pickup/drop off
                                                                charges. </p>
                                                        </td>
                                                    </div>
                                                   
                                                    
                                                    
                                                </tr> -->
                                                <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                    <div class="col-sm-3 col-md-3">
                                                        <td>
                                                            <b><label>Tailoring
                                                                    Service:</label></b>
                                                        </td>
                                                    </div>
                                                    <div class="col-sm-4 col-md-4">
                                                        <td>
                                                            <input type="text"  size="40"
                                                                class="form-control"
                                                                placeholder="Tailored item cost"
                                                                formControlName="tailoring">
                                                        </td>
                                                    </div>
                                                    <div class="col-sm-5 col-md-5">
                                                        <td>
                                                            <p ><i class="fa
                                                                    fa-percent"
                                                                    style="margin-right:
                                                                    5px;font-size:
                                                                    18px;"></i><b>Rs.
                                                                    299 + 4%</b> of
                                                                tailored item cost</p>
                                                        </td>
                                                    </div>
                                                  
                                                  
                                                    
                                                </tr>
                                                <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                    <div class="col-sm-3 col-md-3">
                                                        <td>
                                                            <b><label>Locker
                                                                    Storage:</label></b>
                                                        </td>
                                                    </div>
                                                    <div class="col-sm-4 col-md-4">
                                                        <td>
                                                            <input type="text"  size="40"
                                                                class="form-control"
                                                                placeholder="number of days"
                                                                formControlName="lstorage">
                                                        </td>
                                                    </div>
                                                    <div class="col-sm-5 col-md-5">
                                                        <td>
                                                            <p><i class="fa
                                                                    fa-location-arrow"
                                                                    style="margin-right:
                                                                    5px;font-size:
                                                                    18px;"></i> If any items stays in locker for more than <b>30</b> days, then <b>Rs.100</b> per day is charged for locker storage until that item is shipped/discarded</p>
                                                        </td>
                                                    </div>
                                                   
                                                    
                                                    
                                                </tr>
                                                <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                    <div class="col-sm-3 col-md-3">
                                                        <!-- <td>
                                                            <b><label>You Buy We
                                                                    Ship Service:</label></b>
                                                        </td> -->
                                                    </div>
                                                    <div class="col-sm-4 col-md-4">
                                                        <!-- <td>
                                                            <input type="text"
                                                                class="form-control"  size="40"
                                                                placeholder="No of item you plan to buy"
                                                                formControlName="noitems">
                                                        </td> -->
                                                    </div>
                                                    <div class="col-sm-5 col-md-5">
                                                        <td>
                                                            <p ><i class="fa
                                                                    fa-cart-plus"  size="40"
                                                                    style="margin-right:
                                                                    5px;font-size:
                                                                    18px;"></i>Shop by yourself from anywhere in India & ship to locker.</p>
                                                        </td>
                                                    </div>
                                                   
                                                    
                                                    
                                                </tr>
                                                <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                    <div class="col-sm-12 col-md-12">
                                                        <td>
                                                            <p ><b>Note:</b> Scroll down to calculate domestic pickup charges.</p>
                                                        </td>
                                                    </div>
                                                    
                                                   
                                                    
                                                    
                                                </tr>

                                            </tbody>
                                        </table>
                                        <div class="center" width="100%">
                                            <a href=""><button class="btn"
                                                    type="submit"
                                                    [disabled]="!pricingform.valid">Total</button></a>
                                        </div>
                                    </div>

                                    <div class="col-md-2 col-sm-2">
                                        <b>
                                            <h6>Other Charges:</h6>
                                        </b>
                                        <div class="box">
                                            <p>More Video Requests -
                                                items/packing/unpacking - <b>Rs. 100
                                                    </b>
                                                per item/package</p>
                                            <p>More Photo Requests -
                                                items/packing/unpacking - <b> Rs. 100
                                                    </b>
                                                per item/package</p>
                                            <!-- <p>Personal shopper - commute
                                                charges to
                                                buy products</p> -->
                                            <p>Special packing charges for
                                                fragile items</p>
                                            <p>shipment protection costs</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="vc_empty_space" style="height: 35px;"><span
            class="vc_empty_space_inner"></span>
    </div>

    <!-- <div class="pricing_services">
        <div class="container-fluid">
            <div style="width: 80%;margin: 10px auto;">
                <h3 align="center"> Domestic Pickup Charge Calculator</h3>
                <p style="margin-left: 30px;text-align: center;margin-top:
                    20px;"> </p>
            </div>

            <form [formGroup]="pricingform1" (ngSubmit)="getpickupcharges()">
                <div class="row pricing_services1">
                    <div class="row col-md-12 col-lg-12 col-xl-12">
                        <div class="card">
                           
                            <div class="card-body">
                                <div class="row col-md-12 col-lg-12
                                    col-xl-12 abc">
                                    <div class="col-md-12 col-sm-12 col-xl-12" >
                                        <table width="80%" style="margin: auto;">
                                            <tbody>
                                                <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                    <div class="col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                        <td> 
                                                            <b><label>Pick-up Area Pincode*</label></b>
                                                            <input type="text"
                                                                class="form-control" placeholder="Enter Pick-Up Pincode"
                                                                 size="65" maxlength="6" formControlName="pickupcode"
                                                                 required numbersOnly>
                                                        </td>
                                                    </div>
                                                  
                                                   
                                                </tr>
                                                <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                    <div class="col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                        <td>
                                                            <b><label>Delivery Area Pincode*</label></b>
                                                            <input type="text"
                                                                class="form-control"  size="65" formControlName="delivercode"
                                                                placeholder="Enter Delivery Pincode" maxlength="6"
                                                                 numbersOnly required>
                                                        </td>
                                                    </div>
                                                  
                                                    
                                                </tr>
                                                <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                    <div class="col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                        <td>
                                                            <b><label>Declared Value in INR</label></b>
                                                            <input type="text" min="0"
                                                                class="form-control"  size="65"
                                                                placeholder="Declared Value"
                                                                formControlName="shippingprice">
                                                        </td>
                                                    </div>
                                                    
                                                   
                                                    
                                                </tr>
                                               
                                                <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                    <div class="col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                        <td>
                                                            <b> <label>Weight(Kgs)*</label></b>
                                                            <input type="text" min="0"
                                                            class="form-control"  size="65"
                                                            placeholder="Weight in kgs"
                                                            formControlName="shipiingweight" required>
                                                        </td>
                                                    </div>
                                                   
                                                   
                                                </tr>
                                             
                                                <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                    <div class="col-sm-4 col-md-4">
                                                        <td>
                                                            <b>Optional Fields:</b>
                                                        </td>
                                                    </div>
                                                </tr>
                                                <div class="optional">
                                                    <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                        <div class="col-sm-3 col-md-3">
                                                            <td>
                                                                <b><label>Length(cm)</label></b>
                                                            </td>
                                                        </div>
                                                        <div class="col-sm-6 col-md-6" style="margin-left: 13px;">
                                                            <td>
                                                                <input type="number" min="0"  size="40"
                                                                    class="form-control"
                                                                    placeholder="optional"
                                                                    formControlName="length">
                                                            </td>
                                                        </div>
                                                    
                                                    </tr>
                                                    <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                        <div class="col-sm-3 col-md-3">
                                                            <td>
                                                                <b><label>Width(cm)</label></b>
                                                            </td>
                                                        </div>
                                                        <div class="col-sm-6 col-md-6" style="margin-left: 13px;">
                                                            <td>
                                                                <input type="number" min="0"  size="40"
                                                                    class="form-control"
                                                                    placeholder="optional"
                                                                    formControlName="width">
                                                            </td>
                                                        </div>
                                                    
                                                    </tr>
                                                    <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                        <div class="col-sm-3 col-md-3">
                                                            <td>
                                                                <b><label>Height(cm)</label></b>
                                                            </td>
                                                        </div>
                                                        <div class="col-sm-6 col-md-6" style="margin-left: 13px;">
                                                            <td>
                                                                <input type="number" min="0"  size="40"
                                                                    class="form-control"
                                                                    placeholder="optional"
                                                                    formControlName="height">
                                                            </td>
                                                        </div>
                                                    
                                                    </tr>

                                                </div>
                                                
                                                <tr class="row col-md-12 col-sm-12 col-xl-12 col-lg-12">
                                                    <div class="center1" width="70%">
                                                        <a href=""><button class="btn"
                                                                type="submit"
                                                                [disabled]="!pricingform1.valid">Calculate</button></a>
                                                    </div>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="vc_empty_space" style="height: 40px;"><span
        class="vc_empty_space_inner"></span>
    </div> -->
    <!-- <h3 align="center" class="response shop_mart_one">Shop Smart Spend Less!<br>
        Bring India To Your Doorstep</h3>
    <div class="vc_empty_space" style="height: 12px;"><span
            class="vc_empty_space_inner"></span>
    </div>
    <p align="center" class="res by_any_text buy_any_para">Buy anything from
        India and ship it to your doorstep anywhere
        in
        the world. Get what
        you LOVE from
        India!</p>



  
    <div class="container shopping_cards">
        <div class="row">
            <div class="col-md-6 col-lg-6 col-xl-4">
                <div class="column" id="shopping_card_one">
                    <div class="card" id="firstcard">
                        <div class="card-body shopping_single_card">
                            <img src="assets\Images\pricing\image 35.png"
                                class="card-img-top" width="300" height="150">
                            <h5>Affordable</h5>
                            <p>Be a smart buyer and buy straight
                                from India at low costs</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-xl-4">
                <div class="column" id="shopping_card_two">
                    <div class="card">
                        <div class="card-body shopping_single_card">
                            <img src="assets\Images\pricing\Mask Group-1.png"
                                class="card-img-top" width="300"
                                height="150">
                            <h5>Variety</h5>
                            <p>Buy from various online or local vendors in India</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-xl-4">
                <div class="column" id="shopping_card_three">
                    <div class="card">
                        <div class="card-body shopping_single_card">
                            <img src="assets\Images\pricing\Mask Group.png"
                                class="card-img-top" width="300"
                                height="150">
                            <h5>Authencity</h5>
                            <p>Go vocal for Local. Buy from the
                                authentic sources in India</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>










   
    <h3 align="center" class="pricing_title">Pricing</h3>
    <div class="container pricing_section">
        <div class="col-md-10 mx-auto mb-5">
            <p class="text-left">A <b>one-time Base Charge</b> is applicable to
                all your Add-On services. <b>Pay as you
                    use
                    the Add-On
                    services</b>. No
                hidden
                fees. yourDesiCart service fees apply for the entire transaction
                (until we ship items to your doorstep).
                Once
                items are shipped to your doorstep, it would be considered as a
                new transaction and all service fees
                plus
                Locker
                clock will reset.

                International Packaging & Shipment charges apply. Any carriage
                costs incurred by us to return the item
                to
                the
                vendor will be passed on to the customer</p>
        </div>
    </div>

    <div class="pricing">

        <div class="container">
            <div class="row">

                <div class="col-md-4 col-lg-4 col-xl-4">
                    <div class="card">
                        <div class="card-header">
                            <h5 align="center">Base Charge</h5>
                        </div>
                        <div class="card-body">
                            <h2 align="center"><span style="font-size: 25px;">₹</span>750</h2>
                            <p align="center">Until we ship items to your
                                doorstep</p>
                        </div>
                        <div class="card-footer">
                            <p><img src="assets\Images\Group 1117.png"
                                    height="16" width="16">&nbsp;yourDesiCart
                                India
                                Locker</p>
                            <p><img src="assets\Images\Group 1117.png"
                                    height="16" width="16">&nbsp;Planning &
                                Recommendation</p>
                            <p><img src="assets\Images\Group 1117.png"
                                    height="16" width="16">&nbsp;Tracking,
                                Inspection
                                &
                                Returns</p>
                            <p><img src="assets\Images\Group 1117.png"
                                    height="16" width="16">&nbsp;Consolidation,
                                Packing &
                                Shipping</p>
                            <p><img src="assets\Images\Group 1117.png"
                                    height="16" width="16">&nbsp;Customs
                                Paperwork
                            </p>
                        </div>
                    </div>
                </div>

                <div class="right col-md-8 col-lg-8 col-xl-8 table__content">
                    <table>
                        <tbody>
                            <tr>
                                <td valign="top">
                                    <p><svg width="1.5em" height="1.5em"
                                            viewBox="0 0 16 16" class="bi
                                            bi-geo-alt" fill="currentColor"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style="color: yellowgreen;">
                                            <path fill-rule="evenodd" d="M12.166
                                                8.94C12.696 7.867 13
                                                6.862 13 6A5 5 0 0 0 3 6c0
                                                .862.305 1.867.834 2.94.524
                                                1.062 1.234 2.12 1.96
                                                3.07A31.481 31.481 0 0 0 8
                                                14.58l.208-.22a31.493 31.493 0 0
                                                0 1.998-2.35c.726-.95
                                                1.436-2.008 1.96-3.07zM8
                                                16s6-5.686 6-10A6 6 0 0 0 2 6c0
                                                4.314 6 10 6 10z" />
                                                <path fill-rule="evenodd" d="M8
                                                    8a2 2 0 1 0 0-4 2 2 0
                                                    0 0 0 4zm0 1a3 3 0 1 0 0-6 3
                                                    3 0 0 0 0 6z"
                                                    style="margin-bottom: 10px;"
                                                    />
                                                </svg></p>
                                        </td>
                                        <td>
                                            <p class="table_para"
                                                style="margin-left: 10px;">Address
                                                In India To Store All Your
                                                Purchases. Complimentary For 20
                                                Days From The Day Your First
                                                Package Arrives In
                                                The
                                                Locker After
                                                That Rs.200 Per Week.</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td valign="top">
                                            <p><svg width="1.5em" height="1.5em"
                                                    viewBox="0 0 16 16"
                                                    class="bi bi-journal"
                                                    fill="currentColor"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    style="color: yellowgreen;">
                                                    <path d="M3 0h10a2 2 0 0 1 2
                                                        2v12a2 2 0 0 1-2 2H3a2 2
                                                        0 0 1-2-2v-1h1v1a1 1 0 0
                                                        0 1 1h10a1 1 0 0 0
                                                        1-1V2a1 1 0 0 0-1-1H3a1
                                                        1 0 0 0-1 1v1H1V2a2 2 0
                                                        0 1 2-2z" />
                                                        <path d="M1 5v-.5a.5.5 0
                                                            0
                                                            1 1 0V5h.5a.5.5 0 0
                                                            1 0 1h-2a.5.5 0 0 1
                                                            0-1H1zm0 3v-.5a.5.5
                                                            0 0 1 1 0V8h.5a.5.5
                                                            0 0 1 0 1h-2a.5.5 0
                                                            0 1 0-1H1zm0
                                                            3v-.5a.5.5 0 0 1 1
                                                            0v.5h.5a.5.5 0 0 1 0
                                                            1h-2a.5.5 0 0 1
                                                            0-1H1z" />
                                                        </svg></p>
                                                </td>
                                                <td>
                                                    <p class="table_para"
                                                        style="margin-left:
                                                        10px;">Recommend Online
                                                        Or Local Indian
                                                        Vendors
                                                        Based On Your Shopping
                                                        Needs</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td valign="top">
                                                    <p><svg width="1.5em"
                                                            height="1.5em"
                                                            viewBox="0 0 16 16"
                                                            class="bi
                                                            bi-signpost"
                                                            fill="currentColor"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            style="color:
                                                            yellowgreen;">
                                                            <path d="M7
                                                                1.414V4h2V1.414a1
                                                                1 0 0 0-2 0z" />
                                                                <path
                                                                    fill-rule="evenodd"
                                                                    d="M12.532
                                                                    5H2v4h10.532l1.666-2-1.666-2zM2
                                                                    4a1 1 0 0
                                                                    0-1 1v4a1 1
                                                                    0 0 0 1
                                                                    1h10.532a1 1
                                                                    0 0 0
                                                                    .768-.36l1.933-2.32a.5.5
                                                                    0 0 0
                                                                    0-.64L13.3
                                                                    4.36a1 1 0 0
                                                                    0-.768-.36H2z"
                                                                    />
                                                                    <path d="M7
                                                                        10h2v6H7v-6z"
                                                                        />
                                                                    </svg></p>
                                                            </td>
                                                            <td>
                                                                <p
                                                                    class="table_para"
                                                                    style="margin-left:
                                                                    10px;">Track
                                                                    Your
                                                                    Packages
                                                                    Expected To
                                                                    Arrive
                                                                    At
                                                                    YourDesiCart
                                                                    India Locker</p>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td valign="top">
                                                                <p><svg
                                                                        width="1.5em"
                                                                        height="1.5em"
                                                                        viewBox="0
                                                                        0 16 16"
                                                                        class="bi
                                                                        bi-search"
                                                                        fill="currentColor"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        style="color:
                                                                        yellowgreen;">
                                                                        <path
                                                                            fill-rule="evenodd"
                                                                            d="M10.442
                                                                            10.442a1
                                                                            1 0
                                                                            0 1
                                                                            1.415
                                                                            0l3.85
                                                                            3.85a1
                                                                            1 0
                                                                            0
                                                                            1-1.414
                                                                            1.415l-3.85-3.85a1
                                                                            1 0
                                                                            0 1
                                                                            0-1.415z"
                                                                            />
                                                                            <path
                                                                                fill-rule="evenodd"
                                                                                d="M6.5
                                                                                12a5.5
                                                                                5.5
                                                                                0
                                                                                1
                                                                                0
                                                                                0-11
                                                                                5.5
                                                                                5.5
                                                                                0
                                                                                0
                                                                                0
                                                                                0
                                                                                11zM13
                                                                                6.5a6.5
                                                                                6.5
                                                                                0
                                                                                1
                                                                                1-13
                                                                                0
                                                                                6.5
                                                                                6.5
                                                                                0
                                                                                0
                                                                                1
                                                                                13
                                                                                0z"
                                                                                />
                                                                            </svg></p>
                                                                    </td>
                                                                    <td>
                                                                        <p
                                                                            class="table_para"
                                                                            style="margin-left:
                                                                            10px;">Inspect
                                                                            For
                                                                            Faults
                                                                            &
                                                                            Send
                                                                            1
                                                                            Picture
                                                                            Of
                                                                            The
                                                                            Items
                                                                            Received.
                                                                            Facilitate
                                                                            Returns
                                                                            If
                                                                            Needed.
                                                                            For
                                                                            Multiple
                                                                            360
                                                                            Degree
                                                                            Photos
                                                                            And
                                                                            Videos
                                                                            Rs.100
                                                                            Per
                                                                            Item</p>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        valign="top">
                                                                        <p><svg
                                                                                width="1.5em"
                                                                                height="1.5em"
                                                                                viewBox="0
                                                                                0
                                                                                16
                                                                                16"
                                                                                class="bi
                                                                                bi-cart4"
                                                                                fill="currentColor"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                style="color:
                                                                                yellowgreen;">
                                                                                <path
                                                                                    fill-rule="evenodd"
                                                                                    d="M0
                                                                                    2.5A.5.5
                                                                                    0
                                                                                    0
                                                                                    1
                                                                                    .5
                                                                                    2H2a.5.5
                                                                                    0
                                                                                    0
                                                                                    1
                                                                                    .485.379L2.89
                                                                                    4H14.5a.5.5
                                                                                    0
                                                                                    0
                                                                                    1
                                                                                    .485.621l-1.5
                                                                                    6A.5.5
                                                                                    0
                                                                                    0
                                                                                    1
                                                                                    13
                                                                                    11H4a.5.5
                                                                                    0
                                                                                    0
                                                                                    1-.485-.379L1.61
                                                                                    3H.5a.5.5
                                                                                    0
                                                                                    0
                                                                                    1-.5-.5zM3.14
                                                                                    5l.5
                                                                                    2H5V5H3.14zM6
                                                                                    5v2h2V5H6zm3
                                                                                    0v2h2V5H9zm3
                                                                                    0v2h1.36l.5-2H12zm1.11
                                                                                    3H12v2h.61l.5-2zM11
                                                                                    8H9v2h2V8zM8
                                                                                    8H6v2h2V8zM5
                                                                                    8H3.89l.5
                                                                                    2H5V8zm0
                                                                                    5a1
                                                                                    1
                                                                                    0
                                                                                    1
                                                                                    0
                                                                                    0
                                                                                    2
                                                                                    1
                                                                                    1
                                                                                    0
                                                                                    0
                                                                                    0
                                                                                    0-2zm-2
                                                                                    1a2
                                                                                    2
                                                                                    0
                                                                                    1
                                                                                    1
                                                                                    4
                                                                                    0
                                                                                    2
                                                                                    2
                                                                                    0
                                                                                    0
                                                                                    1-4
                                                                                    0zm9-1a1
                                                                                    1
                                                                                    0
                                                                                    1
                                                                                    0
                                                                                    0
                                                                                    2
                                                                                    1
                                                                                    1
                                                                                    0
                                                                                    0
                                                                                    0
                                                                                    0-2zm-2
                                                                                    1a2
                                                                                    2
                                                                                    0
                                                                                    1
                                                                                    1
                                                                                    4
                                                                                    0
                                                                                    2
                                                                                    2
                                                                                    0
                                                                                    0
                                                                                    1-4
                                                                                    0z"
                                                                                    />
                                                                                </svg></p>
                                                                        </td>
                                                                        <td>
                                                                            <p
                                                                                class="table_para"
                                                                                style="margin-left:
                                                                                10px;">Consolidate
                                                                                Packages
                                                                                From
                                                                                Various
                                                                                Add-On
                                                                                Services</p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            valign="top">
                                                                            <p><i
                                                                                    class="fa
                                                                                    fa-usd"
                                                                                    style="color:
                                                                                    yellowgreen;font-size:
                                                                                    25px;margin-left:
                                                                                    5px;"></i></p>
                                                                        </td>
                                                                        <td>
                                                                            <p
                                                                                class="table_para"
                                                                                style="margin-left:
                                                                                10px;">Package
                                                                                Items
                                                                                Into
                                                                                One
                                                                                Big
                                                                                Box
                                                                                (YourDesiCart)
                                                                                To
                                                                                Save
                                                                                Shipping
                                                                                Costs</p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            valign="top">
                                                                            <p><svg
                                                                                    width="1.5em"
                                                                                    height="1.5em"
                                                                                    viewBox="0
                                                                                    0
                                                                                    16
                                                                                    16"
                                                                                    class="bi
                                                                                    bi-envelope"
                                                                                    fill="currentColor"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    style="color:
                                                                                    yellowgreen;">
                                                                                    <path
                                                                                        fill-rule="evenodd"
                                                                                        d="M0
                                                                                        4a2
                                                                                        2
                                                                                        0
                                                                                        0
                                                                                        1
                                                                                        2-2h12a2
                                                                                        2
                                                                                        0
                                                                                        0
                                                                                        1
                                                                                        2
                                                                                        2v8a2
                                                                                        2
                                                                                        0
                                                                                        0
                                                                                        1-2
                                                                                        2H2a2
                                                                                        2
                                                                                        0
                                                                                        0
                                                                                        1-2-2V4zm2-1a1
                                                                                        1
                                                                                        0
                                                                                        0
                                                                                        0-1
                                                                                        1v.217l7
                                                                                        4.2
                                                                                        7-4.2V4a1
                                                                                        1
                                                                                        0
                                                                                        0
                                                                                        0-1-1H2zm13
                                                                                        2.383l-4.758
                                                                                        2.855L15
                                                                                        11.114v-5.73zm-.034
                                                                                        6.878L9.271
                                                                                        8.82
                                                                                        8
                                                                                        9.583
                                                                                        6.728
                                                                                        8.82l-5.694
                                                                                        3.44A1
                                                                                        1
                                                                                        0
                                                                                        0
                                                                                        0
                                                                                        2
                                                                                        13h12a1
                                                                                        1
                                                                                        0
                                                                                        0
                                                                                        0
                                                                                        .966-.739zM1
                                                                                        11.114l4.758-2.876L1
                                                                                        5.383v5.73z"
                                                                                        />
                                                                                    </svg></p>
                                                                            </td>
                                                                            <td>
                                                                                <p
                                                                                    class="table_para"
                                                                                    style="margin-left:
                                                                                    10px;">Internationally
                                                                                    Ship
                                                                                    YourDesiCart
                                                                                    To
                                                                                    Your
                                                                                    Doorstep
                                                                                    Anywhere
                                                                                    In
                                                                                    The
                                                                                    World</p>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td
                                                                                valign="top">
                                                                                <p><svg
                                                                                        width="1.5em"
                                                                                        height="1.5em"
                                                                                        viewBox="0
                                                                                        0
                                                                                        16
                                                                                        16"
                                                                                        class="bi
                                                                                        bi-pencil"
                                                                                        fill="currentColor"
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        style="color:
                                                                                        yellowgreen;">
                                                                                        <path
                                                                                            fill-rule="evenodd"
                                                                                            d="M12.146.146a.5.5
                                                                                            0
                                                                                            0
                                                                                            1
                                                                                            .708
                                                                                            0l3
                                                                                            3a.5.5
                                                                                            0
                                                                                            0
                                                                                            1
                                                                                            0
                                                                                            .708l-10
                                                                                            10a.5.5
                                                                                            0
                                                                                            0
                                                                                            1-.168.11l-5
                                                                                            2a.5.5
                                                                                            0
                                                                                            0
                                                                                            1-.65-.65l2-5a.5.5
                                                                                            0
                                                                                            0
                                                                                            1
                                                                                            .11-.168l10-10zM11.207
                                                                                            2.5L13.5
                                                                                            4.793
                                                                                            14.793
                                                                                            3.5
                                                                                            12.5
                                                                                            1.207
                                                                                            11.207
                                                                                            2.5zm1.586
                                                                                            3L10.5
                                                                                            3.207
                                                                                            4
                                                                                            9.707V10h.5a.5.5
                                                                                            0
                                                                                            0
                                                                                            1
                                                                                            .5.5v.5h.5a.5.5
                                                                                            0
                                                                                            0
                                                                                            1
                                                                                            .5.5v.5h.293l6.5-6.5zm-9.761
                                                                                            5.175l-.106.106-1.528
                                                                                            3.821
                                                                                            3.821-1.528.106-.106A.5.5
                                                                                            0
                                                                                            0
                                                                                            1
                                                                                            5
                                                                                            12.5V12h-.5a.5.5
                                                                                            0
                                                                                            0
                                                                                            1-.5-.5V11h-.5a.5.5
                                                                                            0
                                                                                            0
                                                                                            1-.468-.325z"
                                                                                            />
                                                                                        </svg></p>
                                                                                </td>
                                                                                <td>
                                                                                    <p
                                                                                        class="table_para"
                                                                                        style="margin-left:
                                                                                        10px;">Customs
                                                                                        Declaration
                                                                                        Paperwork</p>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>



                                                            </div>
                                                        </div>
                                                    </div>


                                                   
                                                    <h3 align="center"
                                                        class="add_on_services">Add-on
                                                        Services</h3>


                                                    <div class="review1">
                                                        <div
                                                            class="container-fluid">
                                                            <div class="row">
                                                                <div
                                                                    class="col-md-6
                                                                    col-lg-4
                                                                    col-xl-4">
                                                                    <div
                                                                        class="column">
                                                                        <div
                                                                            class="card">
                                                                            <div
                                                                                class="card-header">
                                                                                <h6>You
                                                                                    buy
                                                                                    WE
                                                                                    SHIP</h6>
                                                                            </div>
                                                                            <div
                                                                                class="card-body">
                                                                                <h2><span
                                                                                        style="font-size:
                                                                                        25px;">₹</span>20</h2>
                                                                                <h6
                                                                                    class="mt-3" style="font-size: 15px;">per item after 40 items per shipment</h6>
                                                                                <p
                                                                                    class="mt-4">You
                                                                                    can
                                                                                    purchase
                                                                                    products
                                                                                    from
                                                                                    anywhere
                                                                                    in
                                                                                    India
                                                                                    &
                                                                                    ship
                                                                                    to
                                                                                    yourDesiCart
                                                                                    India
                                                                                    Locker</p>
                                  
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="col-md-6
                                                                    col-lg-6
                                                                    col-xl-4">
                                                                    <div
                                                                        class="column">
                                                                        <div
                                                                            class="card">
                                                                            <div
                                                                                class="card-header">
                                                                                <h6>Personal
                                                                                    Shopper</h6>
                                                                            </div>
                                                                            <div
                                                                                class="card-body">
                                                                                <h2><span
                                                                                        style="font-size:
                                                                                        25px;">₹</span>*299</h2>
                                                                                <h6
                                                                                    class="mt-3" style="font-size: 15px;">plus
                                                                                    4%
                                                                                    on
                                                                                    personal
                                                                                    shopped
                                                                                    items</h6>
                                                                                <p
                                                                                    class="mt-4">We
                                                                                    can
                                                                                    shop
                                                                                    on
                                                                                    your
                                                                                    behalf
                                                                                    from
                                                                                    any
                                                                                    local
                                                                                    or
                                                                                    online
                                                                                    store
                                                                                    in
                                                                                    India.</p>
                                                                             
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div
                                                                    class="col-md-6
                                                                    col-lg-6
                                                                    col-xl-4">
                                                                    <div
                                                                        class="column">
                                                                        <div
                                                                            class="card">
                                                                            <div
                                                                                class="card-header">
                                                                                <h6>Package
                                                                                    Pickup</h6>
                                                                            </div>
                                                                            <div
                                                                                class="card-body">
                                                                                <h2><span
                                                                                        style="font-size:
                                                                                        25px;">₹</span>*499</h2>
                                                                                <h6 style="font-size: 15px;"
                                                                                    class="mt-3">domestic courier starting Rs.499 & up</h6>
                                                                                <p
                                                                                    class="mt-4">We
                                                                                    can
                                                                                    facilitate
                                                                                    package
                                                                                    pickup
                                                                                    from
                                                                                    your
                                                                                    requested
                                                                                    location
                                                                                    anywhere
                                                                                    in
                                                                                    India</p>
                                                                             
                                  
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                            </div>
                                                        </div>

                                                        <div
                                                            class="container-fluid">
                                                            <div class="row">
                                                                <div
                                                                    class="col-md-6
                                                                    col-lg-6
                                                                    col-xl-4">
                                                                    <div
                                                                        class="column">
                                                                        <div
                                                                            class="card">
                                                                            <div
                                                                                class="card-header">
                                                                                <h6>Tailoring</h6>
                                                                            </div>
                                                                            <div
                                                                                class="card-body">
                                                                                <h2><span
                                                                                        style="font-size:
                                                                                        25px;">₹</span>*299</h2>
                                                                                <h6
                                                                                    class="mt-3" style="font-size: 15px;">plus 4% of total tailoring charge</h6>
                                                                                <p
                                                                                    class="mt-4">We
                                                                                    assist
                                                                                    with
                                                                                    your
                                                                                    custom
                                                                                    tailoring
                                                                                    needs.
                                                                                    Your
                                                                                    Tailors
                                                                                    or
                                                                                    our
                                                                                    trusted
                                                                                    Tailors</p>
                                   
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="col-md-6
                                                                    col-lg-6
                                                                    col-xl-4">
                                                                    <div
                                                                        class="column">
                                                                        <div
                                                                            class="card">
                                                                            <div
                                                                                class="card-header">
                                                                                <h6>Shipment
                                                                                    Protection</h6>
                                                                            </div>
                                                                            <div
                                                                                class="card-body">
                                                                                <h2><span
                                                                                        style="font-size:
                                                                                        25px;">₹</span>₹₹</h2>
                                                                                <h6 style="font-size: 15px;"
                                                                                    class="mt-3">Higher of Rs.600 or 2% of shipment value</h6>
                                                                                <p
                                                                                    class="mt-4">For
                                                                                    complete
                                                                                    peace
                                                                                    of
                                                                                    mind,
                                                                                    protect
                                                                                    your
                                                                                    shipment
                                                                                    using
                                                                                    DHL
                                                                                    optional
                                                                                    services</p>
                                                                               
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div
                                                                    class="col-md-6
                                                                    col-lg-6
                                                                    col-xl-4">
                                                                    <div
                                                                        class="column">
                                                                        <div
                                                                            class="card">
                                                                            <div
                                                                                class="card-header">
                                                                                <h6>Medicines
                                                                                    From
                                                                                    India</h6>
                                                                            </div>
                                                                            <div
                                                                                class="card-body">
                                                                                <h2><span
                                                                                        style="font-size:
                                                                                        25px;">₹</span>299</h2>
                                                                                <h6
                                                                                    class="mt-3" style="font-size: 15px;">medicines administrative fees</h6>
                                                                                <p
                                                                                    class="mt-4">We
                                                                                    can
                                                                                    buy
                                                                                    Medicines
                                                                                    from
                                                                                    India
                                                                                    on
                                                                                    your
                                                                                    behalf
                                                                                    and
                                                                                    ship
                                                                                    them
                                                                                    to
                                                                                    your
                                                                                    doorstep</p>
                                                                               
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>



                                                    <div class="dig">
                                                        <h3 align="center"
                                                            style="padding-top:
                                                            20px;">Why Choose
                                                            us?</h3>
                                                        <p align="center">Here
                                                            is why?</p>
                                                        <div class="number">
                                                            <img
                                                                src="assets\Images\Group 1094.png"
                                                                width="90%"
                                                                height="600">
                                                        </div>
                                                    </div> -->


                                                    <!-- <app-footer></app-footer> -->
                                                </div>